export const UrlConstants = {
  backend: process.env.REACT_APP_BE_HOST + '/api/v1',
};
